import request from '@/utils/request'

// 查询His系统报告记录列表
export function listHisDiagnosticReport(query) {
    return request({
        url: '/his/hisDiagnosticReport/list',
        method: 'get',
        params: query
    })
}

// 查询His系统报告记录详细
export function getHisDiagnosticReport(id) {
    return request({
        url: '/his/hisDiagnosticReport/' + id,
        method: 'get'
    })
}

// 新增His系统报告记录
export function addHisDiagnosticReport(data) {
    return request({
        url: '/his/hisDiagnosticReport',
        method: 'post',
        data: data
    })
}

// 修改His系统报告记录
export function updateHisDiagnosticReport(data) {
    return request({
        url: '/his/hisDiagnosticReport/update',
        method: 'post',
        data: data
    })
}

// 删除His系统报告记录
export function delHisDiagnosticReport(id) {
    return request({
        url: '/his/hisDiagnosticReport/delete/' + id,
        method: 'post'
    })
}
